import React from "react";
import { Box, Icon } from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa";

interface ColorButtonProps {
  color: string;
  name?: string;
  isSelected?: boolean;
  onClick: () => void;
  size?: "sm" | "md";
  showPlusIcon?: boolean;
}

export function ColorButton({
  color,
  name,
  isSelected = false,
  onClick,
  size = "md",
  showPlusIcon = false,
}: ColorButtonProps) {
  const sizeMap = {
    sm: "20px",
    md: "30px",
  };

  const iconSizeMap = {
    sm: "10px",
    md: "12px",
  };

  return (
    <Box
      as="button"
      type="button"
      w={sizeMap[size]}
      h={sizeMap[size]}
      borderRadius="full"
      bg={color}
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      _hover={{
        transform: "scale(1.1)",
        borderColor: "blue.400",
      }}
      _active={{
        transform: "scale(0.95)",
      }}
      transition="all 0.2s"
      onClick={onClick}
      title={name}
    >
      {showPlusIcon && (
        <Icon as={FaPlus} color="gray.600" fontSize={iconSizeMap[size]} />
      )}
    </Box>
  );
}
